module.exports = __webpack_public_path__ + "static/media/anc5kz.31702a85.pdf";